import React, { useState } from 'react'

import { Form, Header, Input, Button } from 'semantic-ui-react'
import { PASSWORD_REGEX } from '../../../constants';
import { useTranslation } from 'react-i18next';
import { updateSelf } from '../../../services/User/User.service';
import { ultyToast } from '../../Shared/UltyToast/UltyToast'

const UserForm = () => {
  const [t] = useTranslation();

  const [loading, setLoading] = useState(false)

  const [oldpassword, setOldpassword] = useState('')
  const [newpassword, setNewpassword] = useState('')
  const [newpassword2, setNewpassword2] = useState('')

  const handleSubmit = async () => {
    if (newpassword !== newpassword2) {
      ultyToast({ type: 'error', title: t('administration.users.password_not_matching') })
      return
    }

    if (!PASSWORD_REGEX.test(newpassword)) {
      ultyToast({ type: 'error', title: t('administration.users.invalid_password') });
      return;
    }

    setLoading(true)

    try {
      await updateSelf({
        oldpassword,
        newpassword
      });

      ultyToast({ type: 'success', title: t('global.registerSuccess') })

      setOldpassword('');
      setNewpassword('');
      setNewpassword2('');
    } catch(e) {
      if(e.message === 'INVALID_PASSWORD') {
        ultyToast({ type: 'error', title: t('administration.users.previous_password_incorrect') })
      } else if(e.message === 'INVALID_NEW_PASSWORD') {
        ultyToast({ type: 'error', title: t('administration.users.invalid_password') })
      } else {
        ultyToast({ type: 'error', title: t('global.anErrorOccurred') })
      }
    }
    setLoading(false)
  }

  return (
    <Form>
      <Header>{t('administration.users.header')}</Header>
      <Form.Field
        control={Input}
        name="oldpassword"
        type="password"
        value={oldpassword}
        onChange={(evt, dt) => setOldpassword(dt.value)}
        label={t('administration.users.current')}
        placeholder={t('administration.users.current')}
      />
      <Form.Field
        control={Input}
        name="newpassword"
        type="password"
        value={newpassword}
        onChange={(evt, dt) => setNewpassword(dt.value)}
        label={t('administration.users.new')}
        placeholder={t('administration.users.new')}
      />
      <Form.Field
        control={Input}
        name="newpassword2"
        type="password"
        value={newpassword2}
        onChange={(evt, dt) => setNewpassword2(dt.value)}
        label={t('administration.users.confirm_new')}
        placeholder={t('administration.users.confirm_new')}
      />

      <div style={{ textAlign: 'right' }}>
        <Button color="teal" type="submit" loading={loading} disabled={loading} onClick={handleSubmit}>{t('global.save')}</Button>
      </div>
    </Form>
  )
}

export default UserForm
